import { Locale } from '@ps-smart-cp/ppfw-client';

const depreciationMethodNameConfig = {
  twoHundredDclBalMethod: new Map([
    [Locale.ja, '200%定率法'],
    [Locale.en, 'Two Hundred Dcl Bal Method'],
  ]),
  twoHundredFiftyDclBalMethod: new Map([
    [Locale.ja, '250%定率法'],
    [Locale.en, 'Two Hundred Fifty Dcl Bal Method'],
  ]),
  straightLineMethod: new Map([
    [Locale.ja, '定額法'],
    [Locale.en, 'Straight Line Method'],
  ]),
  monthlyInstallmentDepreciation: new Map([
    [Locale.ja, '月割償却'],
    [Locale.en, 'Monthly Installment Depreciation'],
  ]),
  equalDepreciation: new Map([
    [Locale.ja, '均等償却'],
    [Locale.en, 'Equal Depreciation'],
  ]),
  immediateDepreciation: new Map([
    [Locale.ja, '即時償却'],
    [Locale.en, 'Immediate Depreciation'],
  ]),
  oldDclBalMethod: new Map([
    [Locale.ja, '旧定率法'],
    [Locale.en, 'Old Dcl Bal Method'],
  ]),
  oldStraightLineMethod: new Map([
    [Locale.ja, '旧定額法'],
    [Locale.en, 'Old Straight Line Method'],
  ]),
  nonDepreciation: new Map([
    [Locale.ja, '非償却'],
    [Locale.en, 'Non Depreciation'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { depreciationMethodNameConfig };
